<template>
  <div class="listModel">
    <div class="modelHeader ">
      <div class="headerTitle">
        <h2>版本列表</h2>
      </div>
      <div class="headerbut">
        <el-button size="mini" type="primary" @click="createBy">新增</el-button>
      </div>
    </div>
    <div class="sysTable">
      <el-table :data="List" height="500px" v-loading="loading" style="width: 100%">
        <el-table-column prop="version" label="版本号" align="center" min-width="150">
        </el-table-column>
        <el-table-column prop="fileName" label="规范文件" align="center" min-width="150">
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button @click="update(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="download(scope.row)" type="text" size="small">下载</el-button>
            <el-popover placement="top" width="160" :ref="scope.$index">
              <p>确认删除该记录？</p>
              <div style="text-align: right; margin: 0;">
                <el-button size="mini" type="text" @click="scope._self.$refs[scope.$index].doClose();">取消</el-button>
                <el-button size="mini" type="primary" @click="scope._self.$refs[scope.$index].doClose();deleteBy(scope.row);">确定</el-button>
              </div>
              <el-button slot="reference" type="text" size="small" style="margin-left: 10px;">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog append-to-body title="新增版本" center :visible.sync="addVisible" width="800px" v-if="addVisible" :close-on-click-modal="false">
      <addVersion @cancel="cancel" @submit="submit"></addVersion>
    </el-dialog>
    <el-dialog append-to-body title="编辑版本" center :visible.sync="editVisible" width="800px" v-if="editVisible" :close-on-click-modal="false">
      <editVersion @cancel="cancelEdit" @submit="submit" :editData='editData'></editVersion>
    </el-dialog>
  </div>
</template>

<script>
import { GetVsList, addVs, updateVs, delVs } from "@/api/Standard.js";
import { FileUrl } from "@/api/depotApi";
import addVersion from "./addVersion";
import editVersion from "./editVersion";
import { formatDate } from "@/util/util"
export default {
  props: ['versionList'],
  components: {
    addVersion,
    editVersion,
  },
  data() {
    return {
      userInfo: '',
      List: [],
      loading: false,
      addVisible: false,
      editVisible: false,
      editData: {}
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      GetVsList({ standardId: this.versionList.id }).then(res => {
        if (res.code == "200") {
          this.List = res.data;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    createBy() {
      this.addVisible = true;
    },
    update(row) {
      let { fileName, filePath, version, id } = row
      this.editData = {
        fileName,
        filePath,
        version,
        id,
      }
      this.editVisible = true;
    },
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          ...data,
          createTime: formatDate(new Date(), 'all'),
          updateTime: formatDate(new Date(), 'all'),
          createUser: this.userInfo.userId,
          updateUser: this.userInfo.userId,
          standardId: this.versionList.id,
        }
        addVs(params).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || '新增成功！');
            this.cancel();
            this.getList();
          } else {
            this.$message.error(res.msg || '新增失败！');
          }
        });
      } else {
        updateVs({ ...data }).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || '修改成功！');
            this.cancelEdit();
            this.getList();
          } else {
            this.$message.error(res.msg || '修改失败！');
          }
        });
      }
    },
    cancel() {
      this.addVisible = false;
    },
    cancelEdit() {
      this.editVisible = false;
    },
    deleteBy(row) {
      delVs(row.id).then(res => {
        if (res.code == "200") {
          this.getList()
        } else {
          this.$message.error(res.msg)
          this.getList()
        }
      })
    },
    download(row) {
      FileUrl({ objectName: row.filePath }).then((res) => {
        if (res.code == 200) {
          window.open(res.data)
        }
      });
    },
  },
}
</script>

<style lang='less' scoped>
.listModel {
  .modelHeader {
    width: 100%;
    .headerTitle {
      text-align: center;
    }
    .headerbut {
      float: right;
      line-height: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StandardMana/components/versionList.vue